<xi-horizontal-tab-bar
  [data]="selectorTabs"
  [activeTabId]="selectedTab"
  color="CX"
  (onTabChange)="onSelectorTabChange($event.detail.tab.id)"
></xi-horizontal-tab-bar>

<div
  class="datasource-selector__search-bar-wrapper"
  *transloco="let t; read: 'datasource-selector-component'"
>
  <xi-search-box
    placeholder="{{ t('search') }}"
    [stretch]="true"
    [outline]="'text'"
    [value]="searchValue"
    (keyup)="onSearch($event.target.value)"
    (onCancelClick)="onSearch('')"
  ></xi-search-box>
</div>

<div
  class="datasource-selector__dropdown-list"
  [ngClass]="
    selectedTab === 'analyses'
      ? 'datasource-selector__tab-content--display'
      : 'datasource-selector__tab-content--hide'
  "
>
  @if (filteredCollectionsArray && filteredCollectionsArray.length > 0) {
    <ul>
      <div class="datasource-selector__collapsable-item">
        @for (collection of filteredCollectionsArray; track collection) {
          <li>
            <div
              class="datasource-selector__dropdown"
              [class.datasource-selector__select-button--selected]="
                selectedDataSource?.collectionName === collection.collectionId &&
                !collection.isExpanded
              "
            >
              <xi-icon-button
                [hasAnimation]="false"
                [icon]="collection.isExpanded ? 'tree_picker_collapse' : 'tree_picker_expand'"
                (onClick)="onToggleDropdown(collection)"
              ></xi-icon-button>
              <div class="kxi-text-normal kxi-text-600" (click)="onToggleDropdown(collection)">
                {{ collection[0].collectionDisplayName }}
              </div>
            </div>
            @if (collection.isExpanded) {
              <ul>
                @for (analysis of collection; track analysis) {
                  <li>
                    <button
                      class="datasource-selector__select-button"
                      [class.datasource-selector__select-button--selected]="
                        selectedDataSource?.id === analysis.id
                      "
                      (click)="setWidgetDataSource(analysis)"
                    >
                      <p
                        class="datasource-selector__analysis-select-button-content"
                        [matTooltip]="
                          analysis.displayName.length >= 25 ? analysis.displayName : null
                        "
                      >
                        {{ analysis.displayName | truncateEnd: 25 }}
                      </p>
                      <p class="datasource-selector__analysis-select-button-content">
                        {{ analysis.documentCount | humanizeInt }} Docs
                      </p>
                      <p
                        class="datasource-selector__analysis-select-button-content"
                        [matTooltip]="
                          analysis.configName?.length >= 20 ? analysis.configName : null
                        "
                      >
                        {{ analysis.configName | truncateEnd: 20 }}
                      </p>
                      <p class="datasource-selector__analysis-select-button-content">
                        {{ analysis.modifiedAt | lexDate }}
                      </p>
                      <div
                        [ngClass]="
                          analysis.notes ? 'datasource-selector--show' : 'datasource-selector--hide'
                        "
                        class="datasource-selector__analysis-select-button-content datasource-selector__select-button-notepad-icon"
                      >
                        <xi-icon-button
                          icon="notepad"
                          [hasAnimation]="false"
                          [tooltip]="{
                            text: analysis.notes,
                          }"
                        ></xi-icon-button>
                      </div>
                      <div
                        [ngClass]="
                          selectedDataSource?.id === analysis.id
                            ? 'datasource-selector--show'
                            : 'datasource-selector--hide'
                        "
                        class="datasource-selector__analysis-select-button-content"
                      >
                        <xi-icon icon="circle_check_filled" color="CX"></xi-icon>
                      </div>
                    </button>
                  </li>
                }
              </ul>
            }
          </li>
        }
      </div>
    </ul>
  } @else {
    <div
      class="datasource-selector__no_results"
      *transloco="let t; read: 'datasource-selector-component'"
    >
      <p class="kxi-text-xlarge">{{ t('no-results') }}</p>
    </div>
  }
</div>

<div
  class="datasource-selector__dropdown-list"
  [ngClass]="
    selectedTab === 'groups'
      ? 'datasource-selector__tab-content--display'
      : 'datasource-selector__tab-content--hide'
  "
>
  @if (filteredAnalysisGroupsArray && filteredAnalysisGroupsArray.length > 0) {
    <ul>
      <div class="datasource-selector__collapsable-item">
        @for (group of filteredAnalysisGroupsArray; track group) {
          <li>
            <button
              class="datasource-selector__select-button"
              [class.datasource-selector__select-button--selected]="
                selectedDataSource?.id === group.id
              "
              (click)="setWidgetDataSource(group)"
            >
              <p
                class="datasource-selector__group-select-button-content"
                [matTooltip]="group.displayName.length >= 25 ? group.displayName : null"
              >
                {{ group.displayName | truncateEnd: 25 }}
              </p>
              <p class="datasource-selector__group-select-button-content">
                {{ group.documentCount | humanizeInt }} Docs
              </p>
              <p class="datasource-selector__group-select-button-content">
                {{ group.modifiedAt | lexDate }}
              </p>
              <div
                [ngClass]="
                  selectedDataSource?.id === group.id
                    ? 'datasource-selector--show'
                    : 'datasource-selector--hide'
                "
                class="datasource-selector__group-select-button-content"
              >
                <xi-icon icon="circle_check_filled" color="CX"></xi-icon>
              </div>
            </button>
          </li>
        }
      </div>
    </ul>
  } @else {
    <div
      class="datasource-selector__no_results"
      *transloco="let t; read: 'datasource-selector-component'"
    >
      <p class="kxi-text-xlarge">{{ t('no-results') }}</p>
    </div>
  }
</div>
